import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-program-card[routerLinkStr][localeStr][backgroundImageStr]',
    templateUrl: './program-card.component.html',
    styleUrls: ['./program-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgramCardComponent implements OnInit {

  @Input() routerLinkStr: string;
  @Input() localeStr: string;
  @Input() backgroundImageStr: string;

  constructor() { }

  ngOnInit(): void {
  }

}
